<script>
import Layout from "../_layouts/main"
import PageHeader from "@/components/page-header"
import Content from '../../components/transaction/retouch.vue'

/**
 * Transaction Data Retouch Page View
 */
export default {
  components: {
    Layout,
    PageHeader,
    Content
  },
  data() {
    return {
      title: "",
      state: ''
    }
  },
  mounted() {
    this.title = this.$t('데이터') + ' ' + this.$t('보정')
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <Content />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
